var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgXp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.419417 0.0117188H5.12621L7.61942 6.97871C8.59806 9.72822 9.18058 11.7399 9.36699 13.0137C9.53786 12.2214 9.72427 11.4525 9.92621 10.7069C10.1437 9.96123 10.3689 9.2156 10.6019 8.46997L13.235 0.0117188H18.1282L11.4641 17.7205L18.1282 35.9884H13.235L10.8583 29.1379C10.3767 27.7709 9.98835 26.5438 9.6932 25.4564C9.39806 24.369 9.18835 23.4059 9.06408 22.5671C8.93981 23.6078 8.7301 24.602 8.43495 25.5496L7.61942 28.1127L7.2 29.4641L5.12621 35.9884H0L6.80388 17.7205L0.419417 0.0117188Z",
    fill: "url(#paint0_linear_519_58450)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8078 0.0117188H27.1922C30.268 0.0117188 32.5049 0.788418 33.9029 2.34182C35.301 3.91075 36 6.39618 36 9.79813C36 14.5826 34.5942 17.6739 31.7825 19.0719C30.3689 19.7088 28.3262 20.0273 25.6544 20.0273V35.9884H20.8078V0.0117188ZM25.6544 15.8797C27.6583 15.8797 29.0408 15.4758 29.8019 14.668C30.5786 13.8447 30.967 12.3845 30.967 10.2874C30.967 8.14376 30.5942 6.57483 29.8485 5.58065C29.1029 4.58648 27.9301 4.08939 26.3301 4.08939H25.6544V15.8797Z",
    fill: "url(#paint1_linear_519_58450)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_519_58450",
    x1: 5.3617,
    y1: -4.19832,
    x2: 38.3274,
    y2: 36.6757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000429638,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505093,
    stopColor: "#CFD0D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505193,
    stopColor: "#9FA3A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723958,
    stopColor: "#B1B3B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E7E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_519_58450",
    x1: 5.3617,
    y1: -4.19832,
    x2: 38.3274,
    y2: 36.6757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000429638,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505093,
    stopColor: "#CFD0D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505193,
    stopColor: "#9FA3A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723958,
    stopColor: "#B1B3B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E7E8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXp);
export default __webpack_public_path__ + "static/media/xp.fa36c22d98de9a7d8c3608a03dc963e6.svg";
export { ForwardRef as ReactComponent };